import { render, staticRenderFns } from "./channelConfig.vue?vue&type=template&id=2b31556c&scoped=true&"
import script from "./channelConfig.vue?vue&type=script&lang=js&"
export * from "./channelConfig.vue?vue&type=script&lang=js&"
import style0 from "./channelConfig.vue?vue&type=style&index=0&id=2b31556c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31556c",
  null
  
)

export default component.exports